import { ReactNode } from "react"
import { Navigate } from "react-router-dom"
import { useStores } from "../../models/helpers/useStores"
import { observer } from "mobx-react-lite"
import { isMobile, isTablet } from "react-device-detect"
import { LoadingScreen } from "./LoadingScreen"
import { getAgentProfile } from "../../services/firebase-functions/agentProfile"
import { useQuery } from "@tanstack/react-query"
import Config from "../../config"
import UnsupportedMobileVersion from "./UnsupportedMobileVersion"

export const PrivateRoute = observer(({ children }: { children: ReactNode }) => {
  const { loggedInUser, isAuthLoading, isTripLoading } = useStores()
  const { data: agentProfile, isLoading: isAgentProfileLoading } = useQuery({
    queryKey: ["agentProfile", loggedInUser?.id],
    queryFn: () => getAgentProfile(loggedInUser?.id || ""),
  })
  const doesAgentProfileExist = !isAgentProfileLoading && agentProfile
  const isNotDesktop = isMobile || isTablet

  if (isNotDesktop && Config.environment !== "development") {
    return <UnsupportedMobileVersion />
  }

  if (isAuthLoading || isAgentProfileLoading || isTripLoading) {
    return <LoadingScreen />
  }

  if (loggedInUser && doesAgentProfileExist) {
    return children
  }

  if (loggedInUser && !doesAgentProfileExist) {
    return <Navigate to="/signup" />
  }

  return <Navigate to="/" />
})
